var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isMidjourney)?_c('div',{class:_vm.$style.container},_vm._l((_vm.actions),function(action,index){return _c('VButton',{key:index,attrs:{"color":"primary"},on:{"click":function($event){return _vm.onClick(action)}}},[_vm._v(" "+_vm._s(action)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }